/**
 * Generates an array of credit tier options based on the provided national rates, credit rating,
 * and whether credit verification is enabled.
 *
 * @param {Object} nationalRates - An object containing national rate information. Each key represents
 *                                 a credit tier, and its value contains details such as the label.
 *                                 The `isFallback` property will be excluded from processing.
 * @param {string} creditRating - The current credit rating of the user. Used to determine if a
 *                                credit tier should be marked as "Verified".
 * @param {boolean} creditVerificationEnabled - A flag indicating whether credit verification is enabled.
 *                                              If true, the credit rating will be checked for verification.
 * @returns {Array<Object>} An array of credit tier options, where each option is an object with:
 *                          - `label` {string}: The label of the credit tier, optionally appended with " - Verified".
 *                          - `value` {string}: The key representing the credit tier.
 */
const getCreditTierOptions = (nationalRates, creditRating, creditVerificationEnabled) => {
  const ratesClone = {
    ...nationalRates
  };
  delete ratesClone.isFallback;
  return Object.keys(ratesClone).reduce((acc, key) => {
    const creditVerifiedLabel = creditVerificationEnabled && creditRating && key === creditRating ? ' - Verified' : '';
    acc.push({
      label: (ratesClone?.[key]?.label ?? '') + creditVerifiedLabel,
      value: key
    });
    return acc;
  }, []);
};
export { getCreditTierOptions as default };
